import { IGetItemsParams } from '~src/ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/ts/ServerApi/types/IGetItemsResult';

import { Request } from '../../httpClient/serverApi/requests/Request';
import { IUserIdentityConflict } from './types/IUserIdentityConflict';

export interface IGetUserIdentityConflictsResult extends IGetItemsResult {
  userIdentityConflicts: IUserIdentityConflict[];
}

export class GetUserIdentityConflictsRequest extends Request<IGetItemsParams, IGetUserIdentityConflictsResult> {
  constructor(params: IGetItemsParams) {
    super('getUserIdentityConflicts', params);
  }
}
